export default __webpack_public_path__ + "static-front/media/FlyIcon.7a9bfeb4.svg";